import React from 'react'

const DetailView = () => {
  return (<div>Detail View</div>)
}

export default DetailView;